// @flow
import React from 'react';

import {compose} from 'redux';
import {connect} from 'react-redux';
import {evaluationIsVariant} from '@homeaway/react-experiment';
import HitInfoMobile from './HitInfoMobile';
import HitInfoDesktop from './HitInfoDesktop';
import {media} from '../../utils/breakpoints';
import {injectIntl} from 'react-intl';
import {listingHasPriceSecondary} from '../Price/Price';
import {isDateless} from '../../utils/searchParamsUtils';
import {VRBO_OPAS_SECONDARY_PRICE_EU} from '../../abacus/experiments';

import type {IntlShape} from 'react-intl';
import type {ListingShape as DetailsListingShape} from '../Details/Details';
import type {Shape as GeoDistanceShape} from '../GeoDistance/GeoDistance';
import type {ListingShape as HitListingShape} from '../Hit/Hit';

import type {PriceListingShape} from '../Price/Price';
import type {ListingShape as RatingListingShape} from '../Rating/Rating';
import type {State as ReduxState} from '../../reducers/index';
import type {BadgeShape as Badge} from '../Hit/Hit';
import './HitInfo.less';

export type ListingShape = DetailsListingShape &
    PriceListingShape &
    RatingListingShape &
    GeoDistanceShape & {
        detailPageUrl: string,
        instantBookable: boolean,
        listingId: string,
        minStayRange: {
            minStayHigh: number,
            minStayLow: number
        },
        amenitiesBadges: ?(Badge[]),
        propertyId: string,
        propertyMetadata: ?{
            headline: string
        },
        rankedBadges: ?(Badge[]),
        superlativesBadges: ?(Badge[]),
        unitMessage: ?Object,
        unitMetadata: ?{
            unitName: string
        }
    };

type StateProps = {
    brand: string,
    isDatelessSearch: boolean,
    isHovered: boolean,
    isDesktop: boolean,
    isMetric: boolean,
    fullLocale: string,
    showDesktopHits: boolean
};

type IntlProps = {
    intl: IntlShape
};

export type OwnProps = {
    hitIndex?: number,
    isFreeCancellationOff: boolean,
    listing: HitListingShape,
    listingHasSecondaryPrice?: boolean,
    isPriceAccurateAllowed?: boolean,
    isMultiUnitHit?: boolean
} & IntlProps;

export type Props = OwnProps & StateProps;

export function HitInfo(props: Props) {
    const {showDesktopHits, ...propsToPass} = props;

    if (showDesktopHits) {
        return <HitInfoDesktop {...propsToPass} />;
    }
    return <HitInfoMobile {...propsToPass} />;
}

const mapStateToProps = (
    {
        abacus,
        searchParams: {params},
        map: {listingId: hoveredListingId},
        system: {brand, isDesktop, isMetric, fullLocale, siteFeatures},
        viewport: {breakpoint}
    }: ReduxState,
    {listing}: OwnProps
) => {
    const isHovered = listing.listingId === hoveredListingId && isDesktop;
    const isDatelessSearch = isDateless(params);
    const isPriceAccurateAllowed = evaluationIsVariant(
        abacus[VRBO_OPAS_SECONDARY_PRICE_EU],
        1
    );

    return {
        brand,
        isDatelessSearch,
        isDesktop,
        isHovered,
        isMetric,
        showDesktopHits: media(breakpoint, {
            minWidth: 'SM_MIN'
        }),
        siteFeatures,
        fullLocale,
        listingHasSecondaryPrice: listingHasPriceSecondary(
            listing,
            isPriceAccurateAllowed
        ),
        isPriceAccurateAllowed
    };
};

export default compose(injectIntl, connect(mapStateToProps))(HitInfo);
